import { render } from "./Tavern.vue?vue&type=template&id=68b99c3e"
import script from "./Tavern.vue?vue&type=script&lang=js"
export * from "./Tavern.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__